import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  background-color: var(--color-white);
  padding: 24px;
  border-radius: 10px;
  box-shadow: 4px 4px 29px rgba(19, 69, 186, 0.0855129);
  margin-top: 32px;
  margin-bottom: 16px;
  position: relative;
`

const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 16px;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
`

const Section = styled.div`
  align-self: flex-start;
  width: 100%;
`

const Label = styled.label`
  display: inline-block;
  margin: 1rem 0 0.7rem 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d2f48;
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  width: 100%;
  gap: 16px;
  position: relative;
  justify-content: flex-end;
`

const Textarea = styled.textarea<{ isError: boolean; height?: string }>`
  position: relative;
  width: 100%;
  height: ${({ height }) => (height ? `${height}` : '176px')};
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  //resize: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

const Error = styled.div`
  font-size: 12px;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: -12px;
  color: var(--color-text-error);
`

const InputContainer = styled.div<{ isError: boolean }>`
  width: 100%;
  position: relative;
  border: 1px solid lightgrey;
  border-radius: 10px;
  border-color: ${({ isError }) => (isError ? 'var(--color-text-error)' : 'lightgrey')};

  * {
    padding: 1rem;
    border-radius: inherit;
  }
`

const ToggleSection = styled.div`
  margin: 1rem 0 0.7rem 0;
  width: 100%;
  max-width: 100%;
`

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const ToggleLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #2d2f48;
`
const TitleInput = styled.input<{ isError: boolean }>`
  width: 100%;
  font-size: 16px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid lightgrey;
  outline: none;
  color: #2d2f48;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

export {
  Container,
  Form,
  Section,
  Footer,
  Label,
  Textarea,
  Error,
  InputContainer,
  ToggleSection,
  ToggleRow,
  ToggleLabel,
  TitleInput,
}
